/* import __COLOCATED_TEMPLATE__ from './download-statement.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { Statement } from '@square/dashboard-protos/models/squareup/sfs/external/models/statement';
import { clickElement } from '@banking/ui/utils/dom';
let DownloadStatement = (_class = class DownloadStatement extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _initializerDefineProperty(this, "sfsStatementApi", _descriptor3, this);
  }
  async downloadStatement(statement) {
    try {
      this.args.setIsDownloading(true);
      const data = await this.sfsStatementApi.downloadStatement(statement.downloadUrl);
      const url = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.download = this.statementFileName(statement);
      document.body.appendChild(link);
      clickElement(link);
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      this.sentry.captureException(error);
      // If XHR request fails, fallback to browser's default download behavior
      const link = document.createElement('a');
      link.href = statement.downloadUrl;
      document.body.appendChild(link);
      clickElement(link);
      document.body.removeChild(link);
    } finally {
      this.args.setIsDownloading(false);
    }
  }
  statementFileName(statement) {
    const prefix = `${statement.year}_${statement.month}_${statement.id}_${statement.customerId}`;
    const fileExtension = '.pdf';
    switch (statement.type) {
      case Statement.Type.MONTHLY:
        return this.intl.t('banking.components.statementList.savingsMonthlyStatementFileName', {
          prefix,
          fileExtension
        });
      case Statement.Type.TAX_1099_INT:
        return this.intl.t('banking.components.statementList.savings1099INTTaxFormFileName', {
          prefix,
          fileExtension
        });
      default:
        return `${prefix}${fileExtension}`;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sfsStatementApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "downloadStatement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "downloadStatement"), _class.prototype), _class);
export { DownloadStatement as default };